const RESCHEDULE_STEPS = {
    FREQUENCY: 'frequency',
    CALENDAR: 'calendar',
    CONFIRMATION: 'confirmation',
    SUCCESS: 'success',
    ERROR: 'error',
} as const;

type RescheduleStep = (typeof RESCHEDULE_STEPS)[keyof typeof RESCHEDULE_STEPS];

export {RESCHEDULE_STEPS};
export type {RescheduleStep};
